<template>
  <div>
    <table class="dep-table details-table" style="width: 100%; font-size: 13px; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Sn</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Code</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Item</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Lot No.</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Unit</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Qty.</th>
          <th v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px;">Free Qty.</th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, idx) in orderInvoice?.details || []" :key="idx">
          <tr>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ idx + 1 }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.code }}</td>
            <td style="border:1px solid #E0E0E0;">
              {{ row.product?.name }} {{ row.description && `/ ${row.description}` }}
            </td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.lot_no }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.unit?.name }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.quantity }}</td>
            <td v-if="isFreeItem" style="border:1px solid #E0E0E0; text-align:center;">{{ row.free_qty }}</td>
          </tr>

          <tr
            v-for="(gift, gIdx) in row.gifts || []"
            :key="'gift-' + idx + '-' + gIdx"
          >
            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ gift.product?.code }}</td>
            <td style="border:1px solid #E0E0E0; text-align:left;">
              🎁 {{ gift.product?.name }}
            </td>
            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;">
              {{ gift.product?.unit?.name }}
            </td>
            <td style="border:1px solid #E0E0E0; text-align:center;">
              {{ gift.quantity }}
            </td>
            <td v-if="isFreeItem" style="border:1px solid #E0E0E0; text-align:center;">0</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getCompanyInfo } from "@/plugins/helpers";

export default {
  name: "slsSampleOrderDetailsTable",
  data() {
    return {
      orderInvoice: null,
      isFreeItem: false,
    };
  },
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch("getSampleOrderById", id).then((res) => {
      this.orderInvoice = res;
    });

    this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;
  },
};
</script>
